<!--日清周结首页-->
<template>
    <div class="home-rqzj-container">
        <!--   首页  -->
        <div class="home-rqzj" v-show="showMode==='page'">
            <div class="home-file-title-container">
                高中题库（三层量分定做）
            </div>
            <div class="home-rqzj-base-container">
                <div class="home-subject-par-container">
                    <div class="home-subject-item" @click="viewTreeInfo('22')">数 学</div>
                    <div class="home-subject-item" @click="viewTreeInfo('28')">物 理</div>
                    <div class="home-subject-item" @click="viewTreeInfo('27')">化 学</div>
                </div>
            </div>
        </div>
        <!--  查看  -->
        <div class="home-rqzj" v-show="showMode==='treeDetail'">
            <sclfdz-tree-detail :subject-key="this.subject"
                              :mark-info="this.markInfo"
                              @change-mode="changeModel"/>
        </div>
    </div>
</template>
<script>
import {serviceUrl} from "@/utils/global";
import sclfdzTreeDetail from "@/components/sclfdz/sclfdzTreeDetail.vue";

export default {
    name: "sclfdzHome",
    components: {sclfdzTreeDetail},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    data() {
        return {
            serviceUrl,
            showMode:"page",
            subject:'',
            markInfo:'',
        }
    },
    computed: {},
    created() {

    },
    mounted(){},
    methods: {
        viewTreeInfo(subjectKey){
            this.subject = subjectKey;
            this.markInfo = new Date();
            this.showMode = 'treeDetail';
            this.$emit('change-mode',this.showMode);
        },
        changeModel(){
            this.showMode = 'page';
        }
    }
}
</script>
<style>
.home-rqzj-container{
    width: 100%;
    background-color: #fff;
    height: calc(100vh - 90px);
}
.home-rqzj{
    width: 100%;
    background-color: #fff;
    height: calc(100vh - 90px);
}
.home-rqzj-base-container{
    width: 100%;
    height: calc(100vh - 140px);
    background-color: #fff;
    overflow-y: auto!important;
    padding-bottom: 10px;
    padding-top: 5px;
    font-family: sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}
.home-file-title-container{
    width: 100%;
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
    background-color: #fff;
}
.home-subject-par-container{
    width: 100%;
    height: 100px;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

}
.home-subject-item{
    width: 200px;
    height: 100%;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    display: grid;
    place-items: center;
    margin-right: 30px;
    font-size: 18px;
    font-weight: bold;
    border: 1px solid #0d55a4;
    color: #0d55a4;
    cursor: pointer;
    border-radius: 10px;
}

.home-subject-item:hover{
    color: #fff!important;
    background: #0d55a4!important;
    border: 1px solid #0d55a4;
}
</style>